<template><section><h2>快速搭建项目</h2>
<p><code v-pre>npm install -g @vue/cli</code></p>
<p><code v-pre>vue create hello-world</code>
注意：手动选择 vue3 以及 typescript 选项，可以取消 vuex 选项</p>
<p>在 tsconfig.json 文件中新增以下两行</p>
<pre v-pre><code v-pre>&quot;experimentalDecorators&quot;: true,
&quot;emitDecoratorMetadata&quot;: true,
</code></pre>
<p><code v-pre>npm install -S reflect-metadata use-vue-service</code></p>
<p>然后就可以定义 Service 类，并且@Injectable()来标识该类可注入</p>
<p>再使用 useService(ServiceName)获取类实例</p>
<h2>注意</h2>
<p>不能使用 vite 搭建项目，因为 vite 使用的是 esbuild 而不是 tsc 编译 ts 代码</p>
<h2>最佳实践</h2>
<p>建议将 declareProviders([...])单独放在一个 container component 中，这样可以保证组件本身是干净的。
或者至少要放在 setup 函数的顶部，因为如果出现在 useService 之后，就会导致获取的实例出现异常。</p>
<p>就算有了服务，也不代表所有数据就一定需要放在服务中。
比如控制弹窗是否显示的变量 isModalShow，一般应该放在组件中即可。
当然也不是 100%这样，如果多个组件都需要控制这个弹窗是否显示，就应该把这个变量放在服务中了</p>
<p>建议自己基于 axios/superagent 封装自己的 HttpClientService
然后基于 HttpClientService 封装自己的 DaoService
我个人建议是一个项目只需要一个 DaoService，并不需要按照模块划分成多个。
我理解一个项目大多数情况下很难超过 200 条接口。维护在一个服务中是可以接受的。
再然后 StudentService，TeacherService，ClassService 这些业务 Service 直接注入 DaoService 即可。</p>
<p>数据的生命周期应该和组件的生命周期一致，当组件销毁时，数据也应该跟着销毁。
子组件的生命周期应该受到父组件的生命周期的约束。当父组件销毁时，子组件也要跟着销毁。
如果子组件的销毁完全只受父组件控制，那么可以把所有数据都放在父组件中即可。
如果子组件也会绑定到子路由，则相应的数据也可以绑定到该子组件。
目前来看，数据默认会绑定到全局。其他情况数据应该绑定到路由组件，以及子路由组件上。</p>
</section></template>

